<template>
  <div id="rating">
    <loading :show="apiLoading" />
    <b-modal
      id="modal-rating"
      ref="modalRating"
      footer-class="justify-content-center"
      centered
      scrollable
      body-class="pb-4 px-lg-4"
    >
      <h3 class="text-primary text-center mb-4">感謝您使用台北市政府收據雲平台</h3>

      <b-card class="border-0 shadow">
        <h4 class="text-center mb-3">您滿意本系統嗎？</h4>

        <div class="mb-4">
          <rating-star v-model="rating" :stars="stars" show-text />
        </div>

        <input-text
          ref="formMemo"
          :val="feedback"
          :otherRegEx="'desc'"
          :isText="false"
          :account="'建議事項'"
          :isLabel="false"
          @inputVal="getInputDescVal"
        ></input-text>

        <!-- <b-form-textarea
          v-model="feedback"
          placeholder="建議事項"
          no-resize
          rows="2"
          max-rows="6"
        />-->
      </b-card>

      <template v-slot:modal-footer="{ close }">
        <div class="text-center">
          <b-button variant="primary" class="mx-1" @click="submitFeedback()">送出</b-button>
          <b-button variant="outline-secondary" class="mx-1" @click="close()">取消</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ApiMixin from '@/mixins/api';
import Loading from '@/components/Loading.vue';
import RatingStar from '@/components/RatingStar.vue';
import sleep from '@/utils/sleep';

export default {
  name: 'RatingModal',

  components: {
    Loading,
    RatingStar,
  },

  mixins: [ApiMixin],

  data() {
    return {
      stars: ['非常差', '', '', '', '非常好'],
      rating: 0,
      feedback: '',
    };
  },

  computed: {
    ...mapGetters({
      apiLoading: 'api/isProcessing',
    }),
  },

  methods: {
    // 取得 input 值
    getInputDescVal(val) {
      this.feedback = val;
    },
    openRating() {
      console.log('test');
      this.$root.$emit('bv::show::modal', 'modal-rating');
    },

    async submitFeedback() {
      this.apiStart();
      console.log('填寫滿意度');
      let isSuccess;
      try {
        await sleep(1);
        this.apiStop();
        const data = {
          sfDate: this.$moment().local().format('yyyy-MM-DD HH:mm:ss.SSS'),
          sfRanking: this.rating,
          sfSuggest: this.feedback,
        };
        await this.axios({
          url: '/GovEReceipt/FrontDeskService/SatisfyInsert',
          method: 'post',
          data,
        })
          .then((res) => {
            console.log(res.data);
            isSuccess = res.data;
            console.log('寫進滿意度', isSuccess);
          })
          .catch((error) => {
            isSuccess = false;
            console.log('寫進滿意度失敗', isSuccess);
            console.log(error);
          });
        console.log('結果訊息', isSuccess);
        // 顯示 API 結果訊息 (type, message, title)
        this.showApiMessage(
          isSuccess ? 'success' : 'error',
          isSuccess ? '已收到您的意見回饋！' : '送出意見時發生錯誤！',
          isSuccess ? '執行成功' : '執行失敗'
          // {
          //   confirm: true, // 啟用「取消」按鈕
          // }
        );

        if (isSuccess === true) {
          this.rating = 0;
          this.feedback = '';
          this.$root.$emit('bv::hide::modal', 'modal-rating');
        }
      } catch (error) {
        this.apiStop();
        console.error(error);
      }
    },
  },

  // mounted() {
  //   setTimeout(() => {
  //     this.$root.$emit('bv::show::modal', 'modal-rating');
  //   }, 6000);
  // },
};
</script>
